import axios from "axios";

const BASE_URL = "https://api.watch-more.com/";

export const fetchFromAPI = async (url) => {
  const { data } = await axios.get(`${BASE_URL}${url}`);
  return data;
};
